/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiConfirmModal, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

type Props = {
  onCancel: () => void
  onConfirm: () => void
}

const CancelConfigurationModal: React.FunctionComponent<Props> = ({ onCancel, onConfirm }) => (
  <EuiConfirmModal
    title={
      <FormattedMessage
        id='cps.link.cancelModal.title'
        defaultMessage='Cancel cross-project search configuration'
      />
    }
    aria-labelledby='cpsCancelConfigurationModalTitle'
    titleProps={{
      id: 'cpsCancelConfigurationModalTitle',
    }}
    onCancel={onCancel}
    onConfirm={onConfirm}
    cancelButtonText={
      <FormattedMessage id='cps.link.cancelModal.goBack' defaultMessage='Go back' />
    }
    confirmButtonText={
      <FormattedMessage id='cps.link.cancelModal.proceed' defaultMessage='Proceed' />
    }
    buttonColor='danger'
    data-test-subj='cps-cancelConfigurationModal'
  >
    <EuiText>
      <FormattedMessage
        id='cps.link.cancelModal.message'
        defaultMessage='If you cancel, your selections won’t be saved.'
      />
    </EuiText>
  </EuiConfirmModal>
)

export default CancelConfigurationModal
